export const getInitialState = () => ({
  showBanner: undefined,
});
